interface ValidationResult {
  city_name: string;
  missingFields: string[];
}

export function checkForMissingItineraryDataUtil(destinationList: any[]) {
  const flightFields = [
    "departure_city_name",
    "departure_city_state",
    "departure_city_country",
    "departure_city_country_code",
    "departure_city_latitude",
    "departure_city_longitude",
    "arrival_city_name",
    "arrival_city_state",
    "arrival_city_country",
    "arrival_city_country_code",
    "arrival_city_latitude",
    "arrival_city_longitude",
  ];

  const hotelFields = [
    // "time_of_the_day",
    "accommodation_location_city",
    "accommodation_location_country_code",
    // "accommodation_location_latitude",
    // "accommodation_location_longitude",
    "accommodation_location_name",
    "accommodation_number_of_nights",
  ];
  const missingFieldsList: ValidationResult[] = [];

  destinationList?.forEach((destination) => {
    destination?.tripDetails?.forEach((trip: any) => {
      trip?.itinerary_by_time_of_the_day_data?.forEach((item: any) => {
        let requiredFields: string[] = [];

        if (item?.activity_type === "transportation.flight") {
          requiredFields = flightFields;
        } else if (item?.activity_type === "accommodation.hotel") {
          requiredFields = hotelFields;
        }

        if (requiredFields?.length) {
          // const missingFields = requiredFields?.filter((field) => !(field in item));
          const missingFields = requiredFields.filter((field) => {
            if (field === "departure_city_latitude") {
              return item?.departure_city_latitude === undefined && item?.departure_city_lattitude === undefined;
            }

            if (field === "arrival_city_latitude") {
              return item?.arrival_city_latitude === undefined && item?.arrival_city_lattitude === undefined;
            }
            return item?.[field] === undefined || item?.[field] === null || item?.[field] === "";
          });
          if (missingFields?.length > 0) {
            missingFieldsList?.push({
              city_name: trip?.city_name || "",
              missingFields,
            });
          }
        }
      });
    });
  });

  return missingFieldsList;
}
